var parent = require('../../es/object/get-prototype-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/get-prototype-of.js
// module id = 229
// module chunks = 0 1